import { __awaiter, __generator } from "tslib";
import { DataExtensionsApi, USER_DEFINED_FIELDS_NAMESPACE } from '../../apis/DataExtensionsApi/DataExtensionsApi';
var DataExtensionsService = /** @class */ (function () {
    function DataExtensionsService(_a) {
        var httpClient = _a.httpClient;
        this.dataExtensionsApi = new DataExtensionsApi({ httpClient: httpClient });
    }
    DataExtensionsService.prototype.fetchDataExtensionsSchema = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var schema;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.dataExtensionsApi.fetchUserDefinedDataExtensionsSchema()];
                    case 1:
                        schema = _b.sent();
                        /* istanbul ignore next */
                        this.dataExtendedFieldsMeta = (_a = schema === null || schema === void 0 ? void 0 : schema.jsonSchema) === null || _a === void 0 ? void 0 : _a.properties;
                        return [2 /*return*/, this.dataExtendedFieldsMeta];
                }
            });
        });
    };
    DataExtensionsService.prototype.getDataExtendedFieldsView = function (values, metaOverride) {
        var _this = this;
        if (!values) {
            return [];
        }
        var fields = values.namespaces[USER_DEFINED_FIELDS_NAMESPACE];
        if (!fields) {
            return [];
        }
        return Object.keys(fields)
            .map(function (target) {
            var metaToUse = metaOverride !== null && metaOverride !== void 0 ? metaOverride : _this.dataExtendedFieldsMeta;
            /* istanbul ignore next */
            var meta = metaToUse === null || metaToUse === void 0 ? void 0 : metaToUse[target];
            var value = fields[target];
            if (!meta) {
                return undefined;
            }
            var getDisplayValue = function () {
                if (value === undefined) {
                    return '';
                }
                return meta.type === 'array' && Array.isArray(value) ? value.join(', ') : value;
            };
            return {
                value: getDisplayValue(),
                label: meta.title,
            };
        })
            .filter(function (v) { return v !== undefined; });
    };
    return DataExtensionsService;
}());
export { DataExtensionsService };
//# sourceMappingURL=DataExtensionsService.js.map